// For the add to cart popup functionality 
(function () {
  const popup = document.getElementById('cart-add-popup');
  if (!popup) return;

  const closeBtn = popup.querySelector('.cart-add-popup__close');

  function openPopup() {
    popup.classList.add('is-open');
    popup.removeAttribute('inert');
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('inert', "inert");
  }

  closeBtn.addEventListener('click', closePopup);

  // Expose global hook for later use
  window.showCartAddPopup = openPopup;
  window.hideCartAddPopup = closePopup;
})();

// To update the content of the popup when I add the product to the cart
function updateCartAddPopup(addedItem, cart) {
const popup = document.getElementById('cart-add-popup');
  if (!popup) return;

  // Image
  const img = popup.querySelector('.cart-add-popup__image img');
  if (img) {
    img.src = cart.items[0].image;
    img.alt = cart.items[0].image;
    img.width = 1400;
    img.height = 1400;
  }

  // Link
  const link = popup.querySelector('a[href]');
  if (link) link.href = addedItem.url;

  // Texts
  popup.querySelector('.cart-add-popup__vendor').textContent = addedItem.vendor || '';
  popup.querySelector('.cart-add-popup__title').textContent = addedItem.product_title || '';
  popup.querySelector('.cart-add-popup__price').textContent = addedItem.price || '';
  // Variant options
  if(!addedItem.product_has_only_default_variant){
    popup.querySelector('.cart-add-popup__variant').textContent = addedItem.variant_title || '';
  }
  // Remove Button 
  const removeBtn = popup.querySelector(".cart-add-popup__actions recommendation-remove-from-cart-popup");
  if (removeBtn) {
    removeBtn.dataset.productHandle = cart.items[0].handle;
    removeBtn.dataset.index = addedItem.variant_id;
    removeBtn.querySelector("a").href = `/cart/change?id=${addedItem.key}&quantity=0`;
    }
  // Cart count
  const cartBtn = popup.querySelector('.cart-add-popup__btn--primary span');
  if (cartBtn && cart) {
    cartBtn.textContent = `( ${cart.item_count} )`;
  }
}
// To reload the recomendation products
function reloadMiniCartRecommendations(productId) {
  const container = document.querySelector('.product-recommendations-mini-popup.custom');
  if (!container || !productId) return;

  const url = `/recommendations/products?section_id=recommendation-mini-cart&product_id=${productId}&limit=3&intent=related`;
  container.dataset.url = url;

  fetch(url)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.product-recommendations-mini-cart');

      if (recommendations && recommendations.innerHTML.trim().length) {
        container.innerHTML = recommendations.innerHTML;
      }
    })
    .catch((e) => console.error("Recs Fetch Error:", e))
    .finally(() => {
      if (window.BlsColorSwatchesShopify) window.BlsColorSwatchesShopify.init();
      if (window.BlsSubActionProduct) window.BlsSubActionProduct.init();
      if (window.BlsLazyloadImg) window.BlsLazyloadImg.init();
    });
}